import React, { memo, useEffect, useState } from "react";
import CommonModal from "./CommonModal";
import { Button, Switch } from "..";
import { encryptPayload } from "../../helper/common";

const CheckPasswordModal = ({
  onStatusChange,
  rowData,
  getValue,
  is = false,
  btnText = "",
  btnClass = "",
  isSwitch = false,
  modalTitle = "Enter Password to Change Status",
  disabled = false,
}) => {
  const [isShow, setIsShow] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Handle password change and validation
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (value) {
      setError("");
    } else {
      setError("Password is required");
    }
  };

  const handleShowHide = () => {
    setIsShow(!isShow);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      setError("Password is required");
    } else {
      const encryptToken = encryptPayload(password);
      onStatusChange(!getValue(), encryptToken);
      setIsShow(false);
    }
  };

  return (
    <>
      {isSwitch && (
        <Switch
          getValue={() => getValue()}
          onChange={(e) => {
            setPassword("");
            e.target.blur();
            setIsShow(true);
          }}
          value={getValue()}
          disabled={disabled}
        />
      )}

      {is && (
        <Button
          className={` ${btnClass}`}
          onClick={() => {
            setPassword("");
            setIsShow(true);
          }}
          isDisabled={disabled}
        >
          {btnText}
        </Button>
      )}

      {isShow && (
        <CommonModal
          isShow={isShow}
          handleShowHide={handleShowHide}
          modalTitle={modalTitle}
        >
          <form onSubmit={handleSubmit}>
            <div className="row m-0 p-0">
              <div className="col-md-6 m-0 p-1">
                <label htmlFor="password" className="form-label" required>
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  id="password"
                  placeholder="Enter password"
                  onChange={handlePasswordChange} // Handle password input change
                  value={password}
                  autoFocus
                />
                {error && <div className="text-danger">{error}</div>}
                {/* Show error if password is empty */}
              </div>
            </div>
            <Button type="submit" id="form-submit-btn">
              Submit
            </Button>
          </form>
        </CommonModal>
      )}
    </>
  );
};

export default memo(CheckPasswordModal);
